import React from "react";
import Accordion from "react-bootstrap/Accordion";

const FAQs = () => {
  const faqsData = [
    {
      question: "Where can I directly book a meeting to discuss further with you?",
      answer: "I'd love to chat and provide more insights! You can schedule a meeting with me directly on this link: ",
      link: "https://topmate.io/othmanadi/506441"
    },
    {
      question: "How do you assist clients in refining and realizing their ideas?",
      answer: "My approach is collaborative. I begin by understanding your vision and objectives. Through brainstorming sessions, we'll refine the idea, identify opportunities, and create a clear roadmap to bring it to life. My goal is to ensure your idea is both innovative and feasible."
    },
    {
      question: "Why should I choose to work with you?",
      answer: "With my extensive experience and a keen understanding of the digital landscape, I offer not just technical expertise but also strategic insights. My commitment is to ensure your project's success, from ideation to execution, ensuring it meets your objectives and exceeds expectations."
    },
    {
      question: "What makes your services stand out from the competition?",
      answer: "It's the personal touch and dedication. I don't just offer services; I partner with my clients. By understanding your unique needs and challenges, I provide tailored solutions ensuring optimal results. Plus, with continuous support, you're assured of success every step of the way."
    }
  ];

  return (
    <section id="faq" className="section bg-light">
      <div className="container">
        <div className="row gy-5">
          <div className="col-lg-6 order-1 order-lg-0 wow fadeInUp">
            {/* Heading */}
            <p className="text-center text-lg-start mb-2">
              <span className="bg-primary text-dark px-2">What Next?</span>
            </p>
            <h2 className="text-10 fw-600 text-center text-lg-start mb-5">
              Lets check out how you can reach your goal with me
            </h2>
            {/* Heading end*/}
            <Accordion flush defaultActiveKey="0">
              {faqsData.length > 0 &&
                faqsData.map((faq, index) => (
                  <Accordion.Item eventKey={index} key={index}>
                    <Accordion.Header>{faq.question}</Accordion.Header>
                    <Accordion.Body>
                      {faq.answer}
                      {faq.link && <a
                        class="text-danger"
                        style={{ textDecoration: 'underline', color: 'inherit' }}
                        href={faq.link}
                        target="_blank" rel="noopener noreferrer">Topmate</a>}
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
            </Accordion>
          </div>
          <div
            className="col-lg-6 d-flex align-items-center justify-content-center order-0 order-lg-1 wow fadeIn"
            data-wow-delay="1s"
          >
            {" "}
            <img
              className="img-fluid"
              src="images/faq.png"
              title="FAQ"
              alt="faq"
            />{" "}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQs;
